<template>
  <div id="consumption">
    <div class="form" :class="[$mq, {TA:isTestAchat}]">
      <h1>{{ $t("step2.title") }}</h1>

      <ValidationObserver ref="observer" v-slot="{ valid }" slim>
        <MeterType v-if="hasElec"></MeterType>
        <KnowConsumption></KnowConsumption>
      </ValidationObserver>
    </div>
    <div class="buttons inline right" :class="[isForcedProduct ? 'right' : 'space-between', $mq]">
      <PreviousButton @click="previousStep()" />
      <NextButton @click="nextStep()" :isLoading="loading"/>
    </div>

    <div
        v-if="error"
        class="modal-container"
        :class="$mq"
        @click="close()">
      <div class="modal" :class="$mq">
        <div class="close" @click="close()">x</div>
          <h3 class="consumption-title">{{ $t("step3.error-consumption.title") }}</h3>
          <span>{{ $t("step3.error-consumption.text") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import MeterType from "./consumption/MeterType";
import KnowConsumption from "./consumption/KnowConsumption/";
import NextButton from "../components/NextButton.vue";
import PreviousButton from "../components/PreviousButton.vue";
import { mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      error: false
    };
  },
  computed: {
    ...mapState("energy", ["type"]),
    ...mapState("consumption", ["meterType", "solarPanelsScenario", "knowNetConsumption", "hasSmartMeter", "knowPeakLevel"]),
    ...mapGetters("energy", ["hasElec", "hasGas"]),
    ...mapGetters("consumption", ["activeConsumptions"]),
    ...mapGetters("podium", ["isForcedProduct"]),
    ...mapGetters("common", ["isTestAchat"])
  },
  methods: {
    close: function() {
        this.error = false;
    },
    previousStep: function () {
      this.$router.push({ name: "Calculation", query: this.$route.query });
    },
    nextStep: async function () {

      let isValid = await this.$refs.observer.validate();

      let consumptions = this.activeConsumptions
      consumptions.forEach((consumption) => {
        if((consumption.meterType === 'day' ||
            consumption.meterType === 'night' ||
            consumption.meterType === 'exclusiveNight' ||
            consumption.meterType === 'mono' ||
            consumption.meterType === 'gas')
            && consumption.value > 100000 ) {
          this.error = true
          isValid = false
        }
      })

      if (isValid) {
        try {
          this.loading = true;
          await this.$store.dispatch("consumption/getConsumption");
          if(this.solarPanelsScenario === 'COMM_OFFTAKE_AND_INJECTION' && this.knowNetConsumption === false){
            this.$store.dispatch("consumption/recomputeActiveConsumptionValues", false, {root:true});
          }
          if(this.hasSmartMeter && !this.knowPeakLevel) {
            this.$store.dispatch('consumption/computePeakLevel');
          }
          this.$store.commit("consumption/setValid", true);
          this.$store.dispatch("consumption/save");
          this.loading = false;

          if (this.noSubscribe) {
            this.$router.push({name: "Process", query: this.$route.query});
          } else {
            this.$router.push({name: "Contact", query: this.$route.query});
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  watch: {
    type: {
      immediate: true,
      handler(val) {
        let meterTypes = this.$store.state.consumption.meterType;

        switch (val) {
          case "elec":
            meterTypes = meterTypes.filter(
              (meterTypes) => meterTypes !== "gas"
            );
            if (meterTypes.includes("mono")) meterTypes = ["mono"];
            if (!meterTypes.length) {
              meterTypes = ["day", "night"];
            }

            break;
          case "gas":
            meterTypes = meterTypes.filter(
              (meterTypes) => meterTypes === "gas"
            );
            if (!meterTypes.length) {
              meterTypes = ["gas"];
            }

            break;
          case "both":
            let elecMeterTypes = meterTypes.filter(
              (meterTypes) => meterTypes !== "gas"
            );
            if (!elecMeterTypes.length) elecMeterTypes = ["day", "night"];
            let gasMeterTypes = meterTypes.filter(
              (meterTypes) => meterTypes === "gas"
            );
            if (!gasMeterTypes.length) gasMeterTypes = ["gas"];

            meterTypes = elecMeterTypes.concat(gasMeterTypes);
            break;
        }

        this.$store.commit("consumption/setMeterType", meterTypes);
      },
    },
  },
  created() {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "simulation-step2-consumption",
      "cookie-acceptation": "true",
    });
    window.scrollTo(0, 0);
  },
  components: {
    MeterType,
    KnowConsumption,
    NextButton,
    PreviousButton
  },
};
</script>

<style lang="scss" scoped>
.loading {
  display: inline-block;
  margin-left: 5px;
}
.modal-container {
  position: fixed;
  overflow: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &.mobile {
    padding-top: 170px;
    position: fixed;
  }

  .modal {
    box-shadow: 0 0 7px rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 40%;
    padding: 20px 10px;
    border-top: 15px solid #fdcb47;
    border-radius: 30px;
    margin: 0 30% 20px 0;
    background: white;

    a {
      cursor: pointer;
      color: #fdcb47;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }

    &.mobile {
      position: absolute;
      border-radius: 0;
      top: 0;
      margin: 0;

      .close {
        top: 0;
        right: 20px;
      }
    }

    .close {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
      position: absolute;
      top: -20px;
      right: 0;
      background: black;
      border: 2px solid #fdcb47;
      color: #fdcb47;
      height: 25px;
      width: 25px;
      border-radius: 50%;
    }

    .consumption-title {
      margin: 0;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Consumption.vue